import { Table as AntTable } from "antd";
import type {
  TableProps as AntTableProps,
  GetProp,
  TableColumnsType,
} from "antd";

export { AntTable };
export type { GetProp, TableColumnsType, TableProps as AntTablePropsType, TransferProps as AntTransferPropsType } from "antd";

export interface TableProps<T> extends AntTableProps<T> {
  dataSource?: T[];
  loading?: boolean;
}

export type TableRowSelection<T extends object> = AntTableProps<T>["rowSelection"];

export function Table<T extends Record<string, any>>({
  dataSource,
  loading = false,
  size = "small",
  className,
  pagination,
  ...props
}: TableProps<T>) {
  const compactPagination = pagination === false
    ? false
    : {
        pageSize: 7,
        pageSizeOptions: ["7", "10", "20", "50", "100"],
        showSizeChanger: true,
        ...(typeof pagination === "object" ? pagination : {}),
      };

  return (
    <AntTable
      className={["app-compact-table", className].filter(Boolean).join(" ")}
      dataSource={dataSource}
      loading={loading}
      size={size}
      pagination={compactPagination}
      {...props}
    />
  );
}
